import React from "react";
import MiniDrawer from "../../components/Drawer"
import PortalGrid from "../../components/Portal"

const Portal = (socket) => {
    return (
        <MiniDrawer child={<PortalGrid />} />
    );
};

export default Portal;
